export const pages = [
  {
    title: 'Landing Pages',
    id: 'landing-pages',
    pages: [
      {
        title: 'Advertisement',
        href: '/landing-advertisement',
      },
      {
        title: 'Payment App',
        href: '/landing-payment-app',
      },
      {
        title: 'Marketing',
        href: '/landing-marketing',
      },
      {
        title: 'Software Company',
        href: '/landing-software-company',
      },
      {
        title: 'Course',
        href: '/landing-course',
      },
      {
        title: 'Crypto Currency',
        href: '/landing-crypto',
      },
      {
        title: 'Design Agency',
        href: '/landing-design-agency',
      },
      {
        title: 'Consulting',
        href: '/landing-consulting',
      },
      {
        title: 'Application',
        href: '/landing-application',
      },
      {
        title: 'Domain Hosting',
        href: '/landing-domain-hosting',
      },
      {
        title: 'Travel',
        href: '/landing-travel',
      },
      {
        title: 'Event',
        href: '/landing-event',
      },
    ],
  },
  {
    title: 'Supporting Pages',
    id: 'supporting-pages',
    pages: [
      {
        title: 'About',
        href: '/page-about',
      },
      {
        title: 'Services',
        href: '/page-services',
      },
      {
        title: 'Contact',
        href: '/page-contact',
      },
      {
        title: 'Pricing',
        href: '/page-pricing',
      },
      {
        title: 'Customers',
        href: '/page-customers',
      },
      {
        title: 'Hire Us',
        href: '/page-hire-us',
      },
      {
        title: 'FAQ',
        href: '/page-faq',
      },
      {
        title: 'Privacy Policy',
        href: '/page-privacy',
      },
      {
        title: 'Coming Soon',
        href: '/page-coming-soon',
      },
      {
        title: 'Maintenance Mode',
        href: '/page-maintenance-mode',
      },
      {
        title: 'Cover',
        href: '/page-cover',
      },
      {
        title: 'Not Found',
        href: '/page-not-found',
      },
    ],
  },
  {
    title: 'Auth Pages',
    id: 'auth-pages',
    pages: [
      {
        title: 'Login',
        href: '/page-login',
      },
      {
        title: 'Login Simple',
        href: '/page-login-simple',
      },
      {
        title: 'Sign Up',
        href: '/page-signup',
      },
      {
        title: 'Sign Up Simple',
        href: '/page-signup-simple',
      },
      {
        title: 'Forgot Password',
        href: '/page-forgot-password',
      },
      {
        title: 'Forgot Password Simple',
        href: '/page-forgot-password-simple',
      },
    ],
  },
];
